import {ActivityStatus} from "../../../../enum/activity.enum";
import {Activity} from "../../../../model/activity.model";

export const getCurrentActivities = (activities: Activity[]) => {
  return activities
    .filter((activity) => activity.status === ActivityStatus.RUNNING || activity.status === ActivityStatus.PAUSED)
};
